<form [formGroup]="filterForm" autocomplete="off" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="8px">

  <mat-form-field appearance="outline">
    <mat-label>Geography</mat-label>
    <mat-select formControlName="geographicTargets" multiple>
      <mat-option *ngFor="let geography of geographiesList" [value]="geography">
        {{geography}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Profile Type</mat-label>
    <mat-select formControlName="profileTypes" multiple>
      <mat-option *ngFor="let profileType of profileTypesList" [value]="profileType">
        {{profileType}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Affiliations</mat-label>
    <mat-select formControlName="affiliations" multiple>
      <mat-option *ngFor="let affiliation of affiliationsList" [value]="affiliation">
        {{affiliation}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Name</mat-label>
    <input matInput formControlName="expertName">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Bio/Screener Content</mat-label>
    <input matInput formControlName="bioContent">
  </mat-form-field>

  <button mat-icon-button color="primary" [disabled]="!formHasValues" (click)="resetForm()">
    <mat-icon>clear</mat-icon>
  </button>

</form>